import { graphql, useStaticQuery } from "gatsby"
import { FileNode } from "gatsby-plugin-image/dist/src/components/hooks"
import { string } from "prop-types"

const useSolutionData = () => {
  const graphqlData = useStaticQuery<SolutionGraphqlType>(SolutionsGraphql)
  return graphqlData.allSolutionsJson.nodes[0].solutions
}

export default useSolutionData

// Functions \\

export const getFrontmatter = (
  graphqlData: NodeSolutions["solutions"],
  link: string
) => {
  const slug = link.split("/")[2]
  const SolutionDetails = graphqlData.find(solution => slug === solution.slug)!
  const { title, description } = SolutionDetails.content.childMdx.frontmatter
  const image =
    SolutionDetails.image.childImageSharp?.gatsbyImageData.images.fallback?.src!
  const svg = SolutionDetails.content.childMdx.frontmatter.svg.publicURL
  return { image, title, description, link, svg }
}

type NodeSolutions = {
  solutions: Array<{
    slug: string
    image: FileNode
    content: {
      childMdx: {
        frontmatter: {
          title: string
          description: string
          svg: {
            publicURL: string
          }
        }
      }
    }
  }>
}

type SolutionGraphqlType = {
  allSolutionsJson: {
    nodes: Array<NodeSolutions>
  }
}

const SolutionsGraphql = graphql`
  query AllSolutions {
    allSolutionsJson {
      nodes {
        solutions {
          slug
          image {
            childImageSharp {
              gatsbyImageData(formats: WEBP, placeholder: BLURRED)
            }
          }
          content {
            childMdx {
              frontmatter {
                title
                description
                svg {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
`
